import { getHeightInFeetAndInch } from "@/utils/va-order-test/index.js";
import { reformatPhone } from '@/utils/va-order-test/phoneAreaCode/reformatPhone.js'
import moment from "moment";
import { formatPhoneNumber } from "./checkPhoneInput";
const areaCodesCountryMap = require("@/utils/va-order-test/phoneAreaCode/areaCodesCountryMap.json");

/* 
 * format patient object from getPatientByIdApi to the one used in order page frontend
 */
export function formatPatientFromGetPatientApi(patient) {
  let foundEmail = patient.patient_contact && patient.patient_contact
    .find(p => p.contact_description === "email" && p.contact_details !== "");
  let email = foundEmail ? foundEmail.contact_details : "";
  let guardianEmail = patient.guardian_email || "";

  let foundPhone = patient.patient_contact && patient.patient_contact
    .find(p => p.contact_description === "phone" && p.contact_details !== "");
  
  let areaCode = "+1"
  let phone = ""
  if (foundPhone) {
    let rawPhone = foundPhone.contact_details.replace(/\D/g, '');
    if (rawPhone.length != 0) {
      const PNF = require('google-libphonenumber').PhoneNumberFormat;
      const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
      if (rawPhone.length === 10 && patient.patient_address[0].country === "US") {
        rawPhone = "1" + rawPhone
      }
      try {
        const number = phoneUtil.parseAndKeepRawInput('+' + rawPhone);
        const phoneWithAreaCode = phoneUtil.format(number, PNF.INTERNATIONAL);
        let phoneWithAreaCodeArray = phoneWithAreaCode.split(" ");

        if (phoneWithAreaCodeArray[0].slice(1) in areaCodesCountryMap) {

          if (phoneWithAreaCodeArray.length >= 2) {
            areaCode = phoneWithAreaCodeArray[0]
            phone = phoneWithAreaCodeArray.slice(1).join().replace(/\D/g, '');
            phone = formatPhoneNumber(phone, areaCode)
          } else {
            phone = formatPhoneNumber(rawPhone, areaCode);
          }
        } else {
          let res = reformatPhone(rawPhone, patient.patient_address[0].country)
          areaCode = res[1]
          phone = res[2]
        }
      } catch (error) {
        let res = reformatPhone(rawPhone, patient.patient_address[0].country)
        areaCode = res[1]
        phone = res[2]
      }
    }    
  }
  
  // foundPhone ? formatPhoneNumber(foundPhone.contact_details) : "";

  // let foundPhone = patient.patient_contact
  //   .find(p => p.contact_description === "phone" && p.contact_details !== "");
  // let rawPhone = 
  //   foundPhone ? foundPhone.contact_details : "";
  // let reformatPhoneResut = reformatPhone(rawPhone, patient.patient_address[0].country)
  // let phone = 
  //   foundPhone ? formatPhoneNumber(reformatPhoneResut[2]) : "";
  //   // foundPhone ? formatPhoneNumber(foundPhone.contact_details) : "";    
  
  // get height
  let heightInFeet = "0";
  let heightInInch = "0";
  if (patient.patient_height) {
    let { feet, inch } = getHeightInFeetAndInch(patient.patient_height);
    heightInFeet = feet.toString();
    heightInInch = inch.toString();
  }
  // get address
  let addressObj = {
    streetAddress: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    fullAddress: ""
  };
  if (patient.patient_address && patient.patient_address.length > 0) {
    let { street_address, city, state, zipcode, country } = patient.patient_address[0];
    addressObj.streetAddress = street_address ? street_address : "";
    addressObj.city = city ? city : "";
    addressObj.state = state ? state : "";
    addressObj.zipcode = zipcode ? zipcode : "";
    addressObj.country = country ? country : "";
    addressObj.fullAddress = [street_address, city, state, zipcode, country].filter(element => element).join(", ");
  }
  let patientDob = moment(patient.patient_birthdate);
  if (!patientDob.isValid()) {
    patientDob = "";
  }
  let result = {
    id: patient.patient_id,
    firstName: patient.patient_first_name,
    middleName: patient.patient_middle_name,
    lastName: patient.patient_last_name,
    birthdate: patientDob ? formatBirthdate(patient.patient_birthdate) : "",
    gender: patient.patient_gender,
    email,
    guardianEmail,
    phone,
    ...addressObj,
    heightInFeet,
    heightInInch,
    weight: patient.patient_weight,
    areaCode: areaCode
  };
  return result;
}

function formatBirthdate(birthdate) {
  if (!birthdate) {
    return "";
  }
  let [year, month, day] = birthdate.split("-");
  return month + "/" + day + "/" + year;
}

/* replace user input state name with its abbreviation if any */
const usStateMap = require("../misc/state.json");
export function getStateAbbreviation(stateName) {
  let name = stateName.trim().toLowerCase();
  let stateAbbr = usStateMap[name];
  return stateAbbr ? stateAbbr : stateName;
}